<template>
  <v-navigation-drawer v-model="Drawer" app mobile-breakpoint="991" width="310" class="bg-drawer">
    <vuescroll
      :ops="{
        bar: { background: '#bacfcec0' },
      }"
    >
      <v-list-item>
        <v-list-item-title>
          <v-img
            :src="$vuetify.theme.dark ? require('@/assets/brand/logo2.png') : require('@/assets/brand/logo1.png')"
            class="my-3 mx-auto"
            width="180"
            contain
          ></v-img>
        </v-list-item-title>
      </v-list-item>

      <!-- <v-divider></v-divider> -->

      <v-list nav dense>
        <div v-for="(item1, i) in routesList" :key="i">
          <v-list-group
            v-if="item1.group"
            :prepend-icon="item1.icon"
            no-action
            v-show="item1.permission.includes(Role)"
          >
            <template v-slot:prependIcon>
              <v-icon small right>{{ item1.icon }}</v-icon>
            </template>

            <template v-slot:activator>
              <v-list-item-title>
                {{ item1.title }}
                <v-icon :color="item1.counterValue > 0 ? 'success' : 'transparent'">mdi-circle-small</v-icon>
              </v-list-item-title>
            </template>

            <!-- Nivel 2 (PADRE) -->
            <div v-for="(item2, j) in item1.routes" :key="j">
              <v-list-group
                v-if="item2.group"
                :prepend-icon="item2.icon"
                no-action
                sub-group
                v-show="item2.permission.includes(Role)"
              >
                <template v-slot:prependIcon>
                  <v-icon>mdi-chevron-down</v-icon>
                </template>

                <template v-slot:activator>
                  <v-list-item-title style="padding-left: 15px">
                    {{ item2.title }}
                  </v-list-item-title>
                </template>

                <!-- NIVEL 3 (HIJO NIVEL 2) -->
                <v-list-item
                  v-for="(item3, j) in item2.routes"
                  :key="j"
                  active-class="secondary white--text rounded-small"
                  v-show="item3.permission.includes(Role)"
                  style="text-decoration: none"
                  :to="{ name: item3.path, params: item3.params }"
                  no-action
                >
                  <v-list-item-icon class="ml-n8">
                    <v-icon small>{{ item2.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    {{ item3.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list-group>

              <!-- NIVEL 2 (HIJO NIVEL 1) -->
              <v-list-item
                v-else
                v-show="item2.permission.includes(Role)"
                no-action
                active-class="secondary white--text active-shadow-item"
                :to="{ name: item2.path }"
                class="pl-5"
              >
                <v-list-item-icon>
                  <v-icon small right>{{ item2.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item2.title }}</v-list-item-title>
                </v-list-item-content>

                <!-- Contador -->
                <v-list-item-action>
                  <v-btn
                    v-show="item2.counter"
                    width="24"
                    height="24"
                    fab
                    elevation="0"
                    :color="item2.counterValue > 0 ? 'success' : 'grey lighten-1'"
                  >
                    <small>{{ item2.counterValue }}</small>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
            <v-divider class="mb-2"></v-divider>

            <!-- <v-list-item
              v-for="(item2, j) in item1.routes"
              :key="j"
              :to="{ name: item2.path }"
              style="text-decoration: none;"
            >
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title
                class="overline"
                v-text="item2.title"
              ></v-list-item-title>
            </v-list-item>-->
          </v-list-group>

          <!-- NIVEL 1 (SIN HIJOS) -->
          <v-list-item
            v-else
            v-show="item1.permission.includes(Role)"
            no-action
            active-class="secondary white--text active-shadow-item"
            :to="{ name: item1.path }"
          >
            <v-list-item-avatar class="my-0">
              <v-list-item-icon class="mr-5">
                <v-icon small right>{{ item1.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ item1.title }}</v-list-item-title>
            </v-list-item-content>

            <!-- Contador -->
            <v-list-item-action>
              <v-btn
                dark
                v-show="item1.counter"
                width="24"
                height="24"
                fab
                elevation="0"
                :color="item1.counterValue > 0 ? 'success' : 'grey lighten-1'"
              >
                <small>{{ item1.counterValue }}</small>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
      </v-list>
    </vuescroll>
  </v-navigation-drawer>
</template>

<script>
import vuescroll from "vuescroll";
// import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
  },

  data() {
    return {
      notifData: {},
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    notify() {
      return this.$store.getters["user/GET_NOTIFY"];
    },

    routesList() {
      return [
        {
          title: "Inicio",
          icon: "mdi-home",
          path: "Home",
          permission: [1, 2, 4, 6, 7, 8],
        },
        // DASHBOARD
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          permission: [1, 2, 4, 6, 7],
          group: true,
          routes: [
            {
              title: "General",
              icon: "mdi-circle-small",
              path: "Dashboard",
              permission: [1, 2, 4, 6, 7],
            },
            {
              title: "Tipificaciones",
              icon: "mdi-circle-small",
              path: "Dashboard tipificaciones",
              permission: [1, 2, 4, 6, 7],
            },
            {
              title: "Chat",
              icon: "mdi-circle-small",
              path: "Dashboard WhatsApp",
              permission: [1, 2, 4, 6, 7],
            },
          ],
        },

        // REPORTS MENU
        {
          title: "Reportes",
          icon: "mdi-chart-timeline-variant",
          permission: [1, 2, 4, 6, 7, 10],
          group: true,
          routes: [
            {
              title: "Colas (ACD)",
              icon: "mdi-circle-small",
              path: "Informe de Cola",
              permission: [1, 2, 4, 6, 7, 10],
            },
            {
              title: "Llamadas",
              icon: "mdi-circle-small",
              path: "Información de llamadas",
              permission: [1, 2, 4, 6, 7, 10],
            },
            {
              title: "CDR (Grabaciones)",
              icon: "mdi-circle-small",
              path: "CDR",
              permission: [1, 2, 4, 6, 7, 10],
            },
            {
              title: "CDR (Chat)",
              icon: "mdi-circle-small",
              path: "CDR Whatsapp",
              permission: [1, 2, 4, 6, 7],
            },
            {
              title: "Chats",
              icon: "mdi-circle-small",
              path: "Informe de Chats",
              permission: [1, 2, 4, 6, 7],
            },
            // {
            //   title: "Productividad agentes",
            //   icon: "mdi-circle-small",
            //   path: "Reporte de productividad",
            //   permission: [1, 2, 4]
            // },
            {
              title: "Productividad agentes",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2, 4],
              routes: [
                {
                  title: "Indicadores acumulados",
                  icon: "mdi-circle-small",
                  path: "Indicadores acumulados",
                  permission: [1, 2, 4],
                },
                {
                  title: "Por fecha",
                  icon: "mdi-circle-small",
                  path: "Reporte de productividad",
                  params: { type: "date" },
                  permission: [1, 2, 4],
                },
                {
                  title: "Por rango de fecha",
                  icon: "mdi-circle-small",
                  path: "Reporte de productividad",
                  params: { type: "range" },
                  permission: [1, 2, 4],
                },
                {
                  title: "Por agente",
                  icon: "mdi-circle-small",
                  path: "Reporte de productividad",
                  params: { type: "agent" },
                  permission: [1, 2, 4],
                },
              ],
            },
            {
              title: "Tipificación",
              icon: "mdi-circle-small",
              path: "Reporte de Tipificaciones",
              permission: [1, 2, 4],
            },
            {
              title: "Canales",
              icon: "mdi-circle-small",
              path: "Reporte de Canales",
              permission: [1, 2, 6, 7, 4],
            },
            // CANALES
            {
              title: "Troncales",
              icon: "mdi-circle-small",
              path: "Canales",
              permission: [1, 2, 4],
            },
            // TARIFICADOR
            {
              title: "Tarificador",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2, 4],
              routes: [
                {
                  title: "Tarifador básico",
                  icon: "mdi-circle-small",
                  path: "Reporte Tarificador",
                  permission: [1, 2, 4],
                },
                {
                  title: "Tarifador marcador",
                  icon: "mdi-circle-small",
                  path: "Reporte Tarificador Marcador",
                  permission: [1, 2, 4],
                },
              ],
            },
          ],
        },
        // MONITORING MENU
        {
          title: "Monitoreo",
          icon: "mdi-monitor",
          permission: [1, 2, 4, 6, 7, 10],
          group: true,
          routes: [
            {
              title: "Colas (ACD)",
              icon: "mdi-circle-small",
              path: "Monitoreo de colas",
              permission: [1, 2, 4, 6, 7, 10],
            },
            {
              title: "Extensiones",
              icon: "mdi-circle-small",
              path: "Estado de las estaciones",
              permission: [1, 2, 4, 6, 7, 10],
            },
            {
              title: "Llamadas",
              icon: "mdi-circle-small",
              path: "Llamadas activas",
              permission: [1, 2, 4, 6, 7],
            },
            {
              title: "Pausas activas",
              icon: "mdi-circle-small",
              path: "Pausas activas",
              permission: [1, 2, 4],
            },
          ],
        },
        // AGENTS MENU
        {
          icon: "mdi-headset",
          title: "Agentes",
          group: true,
          permission: [1, 2, 4, 7],
          routes: [
            {
              title: "Creados por tí",
              icon: "mdi-circle-small",
              path: "Agentes creados",
              permission: [1, 2, 4, 7],
            },
            {
              title: "Historial de actividad",
              icon: "mdi-circle-small",
              path: "Historial agente",
              permission: [1, 2, 4, 7],
            },
            {
              title: "Bloqueados",
              icon: "mdi-circle-small",
              path: "Agentes bloqueados",
              permission: [1, 2, 4, 7],
            },
            {
              title: "Historial de bloqueos",
              icon: "mdi-circle-small",
              path: "Historial de bloqueados",
              permission: [1, 2, 4, 7],
            },
            {
              title: "Asistencia del día",
              icon: "mdi-circle-small",
              path: "Asistencia del día",
              permission: [1, 2, 4, 7],
            },
            {
              title: "Historial asistencia",
              icon: "mdi-circle-small",
              path: "Historial de asistencia",
              permission: [1, 2, 4, 7],
            },
          ],
        },

        // SETTINGS MENU
        {
          title: "Configuración",
          icon: "mdi-tune-variant",
          permission: [1, 2, 7],
          group: true,
          routes: [
            {
              title: "Usuarios",
              icon: "mdi-circle-small",
              path: "Usuarios",
              permission: [1, 2, 6, 7, 8],
            },
            {
              title: "Colas (ACD)",
              icon: "mdi-circle-small",
              path: "Colas",
              permission: [1, 2],
            },
            {
              title: "Campañas",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2, 7],
              routes: [
                {
                  title: "Estado de campañas",
                  icon: "mdi-circle-small",
                  path: "Configurar Campañas",
                  permission: [1, 2, 7],
                },
                {
                  title: "Nombre de variables",
                  icon: "mdi-circle-small",
                  path: "Nombre de variables",
                  permission: [1, 2, 7],
                },
              ],
            },
            {
              title: "Pausas",
              icon: "mdi-circle-small",
              path: "Configurar Pausas",
              permission: [1, 2],
            },
            {
              title: "Contactos",
              icon: "mdi-circle-small",
              path: "Contacts",
              permission: [1, 2],
            },
            {
              title: "Directorio",
              icon: "mdi-circle-small",
              path: "Directorio",
              permission: [1, 2],
            },
            {
              title: "Chat SMS predefinidos",
              icon: "mdi-circle-small",
              path: "Mensajes predefinidos",
              permission: [1, 2],
            },
            {
              title: "Calidad",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2],
              routes: [
                {
                  title: "Categorías",
                  icon: "mdi-circle-small",
                  path: "Categorias",
                  permission: [1, 2],
                },
                {
                  title: "Evaluaciones",
                  icon: "mdi-circle-small",
                  path: "Evaluaciones",
                  permission: [1, 2],
                },
              ],
            },
            {
              title: "Tarificador",
              icon: "mdi-circle-small",
              path: "Tarificador",
              permission: [1, 2],
            },
            {
              title: "Formulario/Enlaces",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2],
              routes: [
                {
                  title: "Formularios",
                  icon: "mdi-circle-small",
                  path: "Crear Encuesta",
                  permission: [1, 2],
                },
                {
                  title: "Enlaces",
                  icon: "mdi-circle-small",
                  path: "Crear enlaces",
                  permission: [1, 2],
                },
              ],
            },
            {
              title: "Extensiones",
              icon: "mdi-circle-small",
              path: "Extensiones",
              permission: [1, 2, 6],
            },
          ],
        },

        // QUALITY MENU
        {
          title: "Calidad",
          icon: "mdi-shield-check",
          group: true,
          permission: [1, 2, 4],
          routes: [
            {
              title: "Crear evaluación",
              icon: "mdi-circle-small",
              path: "Pruebas",
              permission: [1, 2, 4],
            },
            {
              title: "Reportes de evaluaciones",
              icon: "mdi-circle-small",
              path: "Reporte de Pruebas",
              permission: [1, 2, 4],
            },
            {
              title: "Registros por auditar",
              icon: "mdi-circle-small",
              path: "Registros por auditar",
              permission: [1, 2, 4],
              counter: true,
              counterValue: this.notify?.record_audited || 0,
            },
          ],
        },
        {
          title: "Citas",
          icon: "mdi-calendar-badge",
          group: true,
          permission: [1, 2],
          routes: [
            {
              title: "Plantillas",
              icon: "mdi-circle-small",
              path: "Citas - Plantillas",
              permission: [1, 2],
            },
            {
              title: "Citas",
              icon: "mdi-circle-small",
              path: "Citas - Lista",
              permission: [1, 2],
            },
            {
              title: "Especialidades",
              icon: "mdi-circle-small",
              path: "Citas - Especialidades",
              permission: [1, 2],
            },
            {
              title: "Responsables",
              icon: "mdi-circle-small",
              path: "Citas - Responsables",
              permission: [1, 2],
            },
            {
              title: "Campañas",
              icon: "mdi-circle-small",
              path: "Citas - Campañas",
              permission: [1, 2],
            },
          ],
        },
        {
          title: "Devolución de llamadas",
          icon: "mdi-arrow-u-left-top-bold",
          path: "Devolucion de Llamadas",
          permission: [1, 2, 4],
        },
        {
          title: "Tipificación",
          icon: "mdi-tag",
          path: "Tipificacion",
          permission: [1, 2],
        },
        {
          title: "Encuestas",
          icon: "mdi-poll",
          path: "Encuestas",
          permission: [1, 2],
        },
        {
          title: "Deep Encuestas",
          icon: "mdi-poll",
          path: "Deep Surveys",
          permission: [1, 2, 4],
        },
        {
          title: "Campañas",
          icon: "mdi-alarm-bell",
          path: "Campañas",
          permission: [1, 2],
        },
        {
          title: "Formularios",
          icon: "mdi-list-box",
          path: "Formularios",
          permission: [1, 2],
        },
        // {
        //   title: "Formularios",
        //   icon: "mdi-list-box",
        //   path: "Resultados formularios",
        //   permission: [1, 2],
        // },
        {
          title: "Mensajes",
          icon: "mdi-message-processing",
          path: "Mensajes",
          permission: [1, 2, 4],
        },

        // Agents Options
        {
          title: "Inicio",
          icon: "mdi-home",
          path: "Bienvenido",
          permission: [3],
        },
        {
          title: "Tipificación",
          icon: "mdi-tag",
          path: "Tipificacion - Agentes",
          permission: [3],
          counter: true,
          counterValue: this.notify?.typing_count || 0,
        },
        {
          title: "Marcación",
          icon: "mdi-phone",
          path: "Marcacion - Agentes",
          permission: [3],
        },
        {
          title: "Devolucion de Llamadas",
          icon: "mdi-phone-forward-outline",
          path: "Devolucion de Llamadas",
          permission: [3],
        },
        {
          title: "Contactos",
          icon: "mdi-account-multiple",
          path: "Contacts",
          permission: [3],
        },
        {
          title: "Resumen",
          icon: "mdi-chart-line",
          permission: [3],
          group: true,
          routes: [
            {
              title: "CDR",
              icon: "mdi-circle-small",
              path: "Resumen de Actividad - CDR",
              permission: [3],
            },
            {
              title: "Informe de llamadas",
              icon: "mdi-circle-small",
              path: "Resumen de Actividad - Informe de llamadas",
              permission: [3],
            },
            {
              title: "Colas",
              icon: "mdi-circle-small",
              path: "Resumen de Actividad - Colas",
              permission: [3],
            },
            {
              title: "Pausas",
              icon: "mdi-circle-small",
              path: "Resumen de Actividad - Pausas",
              permission: [3],
            },
          ],
        },
        {
          title: "Reporte de Pruebas",
          icon: "mdi-chart-box-outline",
          path: "Reporte de Pruebas - Agentes",
          permission: [3],
          counter: true,
          counterValue: this.notify?.test_report || 0,
        },
        // SCHEDULED TASK
        {
          title: "Tareas programadas",
          icon: "mdi-calendar-clock",
          path: "Tareas programadas",
          permission: [1, 2, 3, 6, 7, 8],
        },
        {
          title: "Formularios/Enlaces",
          icon: "mdi-list-box",
          group: true,
          permission: [3],
          routes: [
            {
              title: "Formularios",
              icon: "mdi-circle-small",
              path: "Formularios",
              permission: [3],
            },
            {
              title: "Enlaces",
              icon: "mdi-circle-small",
              path: "Crear enlaces",
              permission: [3],
            },
          ],
        },
        {
          title: "Chat",
          icon: "mdi-chat",
          path: "Chats",
          permission: [3],
          counter: true,
          counterValue: this.notify?.chats || 0,
        },

        // EXTERNAL CLIENTS SETTINGS MENU
        {
          title: "Config. clientes",
          icon: "mdi-account-heart",
          permission: [1],
          group: true,
          routes: [
            {
              title: "Dashboard general",
              icon: "mdi-circle-small",
              path: "Dashboard 2",
              permission: [1],
            },
            {
              title: "Dashboard colas",
              icon: "mdi-circle-small",
              path: "Dashboard colas",
              permission: [1],
            },
            {
              title: "Clientes",
              icon: "mdi-circle-small",
              path: "Clientes",
              permission: [1],
            },
            {
              title: "Clientes externos",
              icon: "mdi-circle-small",
              path: "Clientes externos",
              permission: [1],
            },
            {
              title: "Informacion de Clientes",
              path: "Informacion de Clientes",
              icon: "mdi-circle-small",
              permission: [1],
            },
            {
              title: "WhatsApp",
              icon: "mdi-circle-small",
              group: true,
              permission: [1, 2],
              routes: [
                {
                  title: "Mensajes predefinidos",
                  icon: "mdi-circle-small",
                  path: "Mensajes predefinidos",
                  permission: [1, 2],
                },
                {
                  title: "Config. Bots",
                  icon: "mdi-circle-small",
                  path: "Configurar Bots",
                  permission: [1, 2],
                },
                {
                  title: "Config. Encuestas",
                  icon: "mdi-circle-small",
                  path: "Configurar encuestas",
                  permission: [1, 2],
                },
                {
                  title: "Config. WhatsApp",
                  icon: "mdi-circle-small",
                  path: "Configurar WhatsApp",
                  permission: [1, 2],
                },
              ],
            },

            {
              title: "Config. WebRTC",
              icon: "mdi-circle-small",
              path: "Configurar WebRTC",
              permission: [1],
            },
            {
              title: "Clientes ext. campañas",
              icon: "mdi-circle-small",
              path: "Cliente externo campañas",
              permission: [1],
            },
            {
              title: "Gateways",
              icon: "mdi-circle-small",
              path: "Gateways",
              permission: [1],
            },
            // TRONCALES
            {
              title: "Troncales",
              icon: "mdi-circle-small",
              path: "Troncales",
              permission: [1],
            },
            {
              title: "Botones de Llamadas",
              icon: "mdi-phone",
              path: "Botones de Llamadas",
              permission: [1],
            },
          ],
        },

        // { title: 'Tipificacion', icon: 'mdi-account-heart', path: "ShowTypifications", permission: [1, 2, 3]},
      ];
    },

    Drawer: {
      get() {
        let drawer = this.$store.getters["layout/DRAWER_VALUE"];
        return drawer === null ? true : drawer;
      },
      set(val) {
        this.$store.commit("layout/SET_DRAWER", val);
      },
    },
  },

  mounted() {
    if (this.isMobile) {
      this.$store.commit("layout/SET_DRAWER", false);
    }
    this.getNotifCounter();
  },

  watch: {
    $route() {
      this.getNotifCounter();
    },
  },

  methods: {
    router(router) {
      this.$router.push({ name: router }).catch((err) => {
        console.warn(err);
      });
    },

    async getNotifCounter() {
      try {
        await this.$store.dispatch("user/GET_NOTIFY");
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>
<style>
.no-padding-left {
  margin-left: -15px;
}
</style>
